import React from 'react';
import classNames from 'classnames';

import { SelectItemOptionProps } from './select-item-option.type';

export const SelectItemOption = ({
  id,
  wrapperClasses,
  className,
  name,
  subtitle,
  description,
  bordered,
  active,
  action,
  icon,
}: SelectItemOptionProps) => {
  const Icon = icon;

  const DefaultItemOption = () => (
    <div className={classNames('flex flex-col gap-4', wrapperClasses as string)} data-testid='select-item' key={id}>
      <button
        type='button'
        className={classNames(
          'flex flex-col justify-center items-center shadow-sm p-4 rounded-md group transition duration-300 ease-in-out grow border-transparent hover:border-negative border dark:shadow-neutral-100/30',
          className ?? ''
        )}
        onClick={action}>
        <Icon className='text-primary w-10 h-10 group-hover:text-primary dark:text-neutral-0 dark:group-hover::text-neutral-0' />
        <span className='mt-2 text-primary font-black text-base group-hover:text-primary dark:text-neutral-0 dark:group-hover::text-neutral-0'>
          {name}
        </span>
        {subtitle && (
          <span className='text-center text-body-xs text-secondary group-hover:text-secondary mx-3 dark:group-hover::text-neutral-0 '>
            {subtitle}
          </span>
        )}
      </button>
      {description && <p className='lg:h-10 text-body-xs text-secondary mx-3'>{description}</p>}
    </div>
  );

  const BorderedItemOption = () => (
    <div className={classNames('flex flex-col gap-4', wrapperClasses as string)} data-testid='select-item' key={id}>
      <button
        type='button'
        className={classNames(
          'flex flex-col justify-center items-center px-3 py-4 rounded-md group transition duration-300 ease-in-out grow border-2 dark:border-neutral-0',
          { 'hover:border-hard dark:hover:bg-white border-hard dark:bg-inverse dark:text-primary': active }
        )}
        onClick={action}>
        <Icon
          className={classNames('text-primary w-6 h-6', {
            'dark:text-negative dark:group-hover:text-neutral-85': active,
          })}
        />
        <span
          className={classNames('mt-2 text-primary text-subtitle-m', {
            'dark:text-negative dark:group-hover:text-neutral-85': active,
          })}>
          {name}
        </span>
        {subtitle && (
          <span
            className={classNames('text-center text-body-xs text-secondary mx-3', {
              'dark:text-negative dark:group-hover:text-neutral-85': active,
            })}>
            {subtitle}
          </span>
        )}
      </button>
      {description && <p className='lg:h-10 text-center text-body-xs text-secondary mx-3'>{description}</p>}
    </div>
  );

  return bordered ? <BorderedItemOption /> : <DefaultItemOption />;
};
